import { render, staticRenderFns } from "./CRDSummary.vue?vue&type=template&id=352683c7"
import script from "./CRDSummary.vue?vue&type=script&lang=js"
export * from "./CRDSummary.vue?vue&type=script&lang=js"
import style0 from "./CRDSummary.vue?vue&type=style&index=0&id=352683c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports